
/**
 * Скрипты шапки
 */
export default class SearchPanel {
    private HAS_VALUE = 'has-value';

    private readonly $holder: JQuery;
    private readonly $searchField: JQuery;

    private selectors = {
        searchField: '.js-search-panel-field',
        btnClear: '.js-search-clear',
    };

    constructor($holder: JQuery) {
        this.$holder = $holder;
        this.$searchField = this.$holder.find(this.selectors.searchField);

        this.changeInputHandler = this.changeInputHandler.bind(this);
        this.clearSearchHandler = this.clearSearchHandler.bind(this);

        this.init();
    }

    private init(): void
    {
        this.$searchField.on('input', this.changeInputHandler);
        this.$holder.on('click', this.selectors.btnClear, this.clearSearchHandler)
    }


    /**
     * Изменение инпута
     * @private
     */
    private changeInputHandler(event): void {
        const value = $(event.target).val() as string;

        value.length ?
            this.$holder.addClass(this.HAS_VALUE) :
            this.$holder.removeClass(this.HAS_VALUE);
    }

    /**
     * Очистка поля
     * @private
     */
    private clearSearchHandler(): void {
        this.$searchField.val('');
        this.$holder.removeClass(this.HAS_VALUE);
        this.$searchField.trigger('focus');
    }
}
